import request from '@/utils/request';
import Resource from '@/api/resource';

class PlanLogsResource extends Resource {
  constructor() {
    super('tasks');
  }

  // 获取计划请求结果
  getPlanLogs(data) {
    return request({
      url: `/${this.uri}`,
      method: 'GET',
      params: data,
    });
  }
}

export { PlanLogsResource as default };
